export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  Boolean(window.matchMedia?.("(prefers-reduced-motion: reduce)").matches);

export const scrollBehavior = () => (prefersReducedMotion() ? "auto" : "smooth");
